export const validLeadAddFormValues = (formValues, isRawLead) => {
  let errors = {};
  const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
  const mobileRegex = /^\d{10}$/;
  const yopmailDomains = [
    "yopmail.com",
    "yopmail.net",
    "yopmail.fr",
    "yopmail.org",
  ];

  const isNextFollowupRequired =
    formValues.selectedFirstFollowupStatus &&
    formValues.selectedFirstFollowupStatus?.next_followup_required;

  const is_Plan_Info_Required =
    formValues.selectedFirstFollowupStatus &&
    formValues.selectedFirstFollowupStatus?.price_required;

  if (!isRawLead && !formValues.custName) {
    errors.custName = "required!";
  }

  if (!isRawLead && !formValues.custMobile) {
    errors.custMobile = "required!";
  } else if (
    formValues.custMobile &&
    !mobileRegex.test(formValues.custMobile)
  ) {
    errors.custMobile = "invalid!";
  }

  if (formValues.custEmail && !emailRegex.test(formValues.custEmail)) {
    errors.custEmail = "invalid!";
  } else if (
    formValues.custEmail &&
    yopmailDomains.some((domain) => formValues.custEmail.includes(domain))
  ) {
    errors.custEmail = "Yopmail email addresses are not allowed!";
  }

  if (!formValues.selectedSource) {
    errors.selectedSource = "required!";
  }

  if (!formValues.selCustomerIntent) {
    errors.selCustomerIntent = "required!";
  }

  if (!formValues.selectedFirstFollowupStatus) {
    errors.selectedFirstFollowupStatus = "required!";
  }

  if (!formValues.firstFollowupDetails) {
    errors.firstFollowupDetails = "required!";
  } else if (
    formValues.firstFollowupDetails &&
    formValues.firstFollowupDetails?.length < 20
  ) {
    errors.firstFollowupDetails = "required!";
  }

  if (!formValues.firstFollowupTime) {
    errors.firstFollowupTime = "required!";
  }

  if (isNextFollowupRequired && !formValues.nextFollowupDate) {
    errors.nextFollowupDate = "required!";
  }

  if (
    (isNextFollowupRequired && !formValues.nextFollowupTime) ||
    (formValues.nextFollowupDate && !formValues.nextFollowupTime)
  ) {
    errors.nextFollowupTime = "required!";
  }

  if (is_Plan_Info_Required && !formValues.selectedPlan) {
    errors.selectedPlan = "required!";
  }

  if (is_Plan_Info_Required && !formValues.leadValueAmount) {
    errors.leadValueAmount = "required!";
  }

  if (
    (formValues.isSelfAssign || formValues.isAssignDifferentReceptionist) &&
    !formValues.selectedGym
  ) {
    errors.selectedGym = "required!";
  }

  if (
    formValues.isAssignDifferentReceptionist &&
    !formValues.selectedReceptionist
  ) {
    errors.selectedReceptionist = "required!";
  }

  return errors;
};

export const validateLeadFolloupForm = (formValues) => {
  let errors = {};

  const isNextFollowupRequired =
    formValues.followupStatus &&
    formValues.followupStatus?.next_followup_required;
  const is_Plan_Info_Required =
    formValues.followupStatus && formValues.followupStatus?.price_required;

  if (!formValues.selCustomerIntent) {
    errors.selCustomerIntent = "required!";
  }

  if (!formValues.followupStatus) {
    errors.followupStatus = "required!";
  }

  if (isNextFollowupRequired && !formValues.nextFollowupDate) {
    errors.nextFollowupDate = "required!";
  }

  if (
    (isNextFollowupRequired && !formValues.nextFollowupTime) ||
    (formValues.nextFollowupDate && !formValues.nextFollowupTime)
  ) {
    errors.nextFollowupTime = "required!";
  }

  if (is_Plan_Info_Required && !formValues.selectedPlan) {
    errors.selectedPlan = "required!";
  }

  if (is_Plan_Info_Required && !formValues.leadValueAmount) {
    errors.leadValueAmount = "required!";
  }

  if (!formValues.remarks) {
    errors.remarks = "required!";
  } else if (formValues.remarks && formValues.remarks?.length < 20) {
    errors.remarks = "required!";
  }

  return errors;
};

export const validationManageLeadForm = (formValues) => {
  let errors = {};

  if (!formValues.selLeadStatus) {
    errors.selLeadStatus = "required!";
  }

  if (!formValues.remarks) {
    errors.remarks = "required!";
  } else if (formValues.remarks && formValues.remarks?.length < 20) {
    errors.remarks = "required!";
  }

  return errors;
};

export const validateEditForm = (formValues, rowData) => {
  let errors = {};
  const mobileRegex = /^\d{10}$/;

  const isCustomerIntent = rowData?.cutomer_intent === "interested";

  if (!formValues.selectedGym) {
    errors.selectedGym = "required!";
  }

  if (formValues.assignToOtherUsers) {
    if (!formValues.selectedOtherUser) {
      errors.selectedOtherUser = "required!";
    }
  } else {
    if (!formValues.selectedReceptionist) {
      errors.selectedReceptionist = "required!";
    }
  }

  if (!formValues.custMobile) {
    errors.custMobile = "required!";
  } else if (!mobileRegex.test(formValues.custMobile)) {
    errors.custMobile = "invalid!";
  }

  if (isCustomerIntent && !formValues.leadValueAmount) {
    errors.leadValueAmount = "required!";
  }

  return errors;
};

export const validationRawLeadForm = (formValues) => {
  let errors = {};

  if (formValues.assignToOtherUsers) {
    if (!formValues.selectedOtherUser) {
      errors.selectedOtherUser = "required!";
    }
  } else {
    if (!formValues.selectedReceptionist) {
      errors.selectedReceptionist = "required!";
    }
  }

  return errors;
};
